import styled from 'styled-components';

// Navigation Scroll Arrows - Desktop only
export const NavScrollArrow = styled.div<{ $direction: 'left' | 'right'; $show: boolean; $hasTournaments?: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  z-index: 110;
  pointer-events: ${({ $show }) => ($show) ? 'auto' : 'none'};
  opacity: ${({ $show }) => ($show) ? 1 : 0};
  transition: opacity 0.2s ease;
  
  ${({ $direction, $hasTournaments }) => $direction === 'left' ? `
    left: 0;
  ` : `
    right: ${$hasTournaments ? '8px' : '0px'}; /* Adjust based on tournament availability */
  `}
  
  /* Only show if it is not touch device */
  @media (hover: none) and (pointer: coarse) {
    display: none;
  }
`;

export const NavArrowIcon = styled.div<{ $direction: 'left' | 'right' }>`
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  align-self: center;
  width: 26px;
  height: 26px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  
  ${({ $direction }) => $direction === 'left' ? `
    left: 0;
  ` : `
    right: 0;
  `}
`;

export const NavArrowSvg = styled.svg<{ $direction: 'left' | 'right' }>`
  width: 18px;
  height: 18px;
  color: white;
  pointer-events: none;
  display: block;
  margin: auto;
  
  ${({ $direction }) => $direction === 'left' ? `
    transform: rotate(90deg);
  ` : `
    transform: rotate(-90deg);
  `}
`;